import _ from 'lodash'

export function templateUrl(urlTemplate, parameters) {
  if (!urlTemplate) return '';
  let resultUrl = urlTemplate;
  // {{param}} style
  resultUrl = resultUrl.replace(/\{\{\s*([a-zA-Z0-9_\.]+)\s*\}\}/g, (_match, keyPath) => {
    const value = _.get(parameters, keyPath);
    return value == null ? '' : encodeURIComponent(String(value));
  });
  // {param} style
  resultUrl = resultUrl.replace(/\{\s*([a-zA-Z0-9_\.]+)\s*\}/g, (_match, keyPath) => {
    const value = _.get(parameters, keyPath);
    return value == null ? '' : encodeURIComponent(String(value));
  });
  // ?{param} style appended as query if present
  resultUrl = resultUrl.replace(/\?\{\s*([a-zA-Z0-9_\.]+)\s*\}/g, (_match, keyPath) => {
    const value = _.get(parameters, keyPath);
    if (value == null) return '';
    try {
      const urlObject = new URL(resultUrl, window.location.origin);
      urlObject.searchParams.set(keyPath, String(value));
      return `?${urlObject.searchParams.toString()}`;
    } catch {
      return '';
    }
  });
  return resultUrl;
}

export function openUrl(url, openInNewTab) {
  try {
    if (openInNewTab) {
      window.open(url, '_blank');
    } else {
      window.location.href = url;
    }
  } catch (e) {
    // noop
  }
}